export default __webpack_public_path__ + "static/media/onboarding_snap_save_2.c4116514.png";